/**
 * @deprecated
 * - `util.clone` is a reexport of lodash/cloneDeep and exists only for backwards compatability reasons
 * - prefer `structuredClone` whenever it can be used for your use-case
 * - prefer direct use of lodash/cloneDeep when necessary
 */
export { default as clone } from 'lodash/cloneDeep';

// deepFreeze prevents the modification of existing property attributes and values, and prevents the addition of new properties.
export const deepFreeze = function (obj) {
  if ('object' !== typeof obj || obj === null) {
    return obj;
  }

  // Retrieve the property names defined on obj
  const propNames = Object.getOwnPropertyNames(obj);

  // Freeze properties before freezing self
  for (const name of propNames) {
    const prop = obj[name];

    // Freeze prop if it is an object
    if (typeof prop === 'object' && prop !== null) deepFreeze(prop);
  }

  // Freeze self (no-op if already frozen)
  return Object.freeze(obj);
};
export function deferred() {
  const deferred = {};
  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}

// async-await friendly way to "sleep" for a bit
export const sleep = milliseconds => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};
export function getDefaultStyleNonce() {
  const nonce = document.getElementById('sas-nc-style')?.nonce;
  return /^{{.*}}$/.test(nonce) ? undefined : nonce;
}
//# sourceMappingURL=util.js.map